import { LazyImport, LazyModule, createLazyComponent } from 'owa-bundling';
export { ReactListViewType };
import renderCouponPeekPlaceHolder from './components/CouponPreviewPlaceholder';
export { getValidCouponIndexesForConversation, getValidCouponIndexesForItem, } from './helpers/getValidCouponIndexes';
var lazyModule = new LazyModule(function () {
    return System.import(/* webpackChunkName: "CouponPeek" */ './lazyIndex');
});
export var lazyFetchCouponData = new LazyImport(lazyModule, function (m) { return m.fetchCouponData; });
export var lazyRemoveCouponFromStore = new LazyImport(lazyModule, function (m) { return m.removeCouponFromStore; });
// Delayed Loaded Components
export var CouponPreviewWell = createLazyComponent(lazyModule, function (m) { return m.CouponPreviewWell; }, function (props) { return renderCouponPeekPlaceHolder(props); });
//# sourceMappingURL=index.js.map